import styled from '@emotion/styled'
import {theme} from '../../../../theme'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

export const AddButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
`

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;

  z-index: 1000;

  display: flex;
  flex-direction: column;

  max-height: 280px;
  overflow-y: auto;

  padding: 8px;

  background: ${theme.colors.input.bg};

  border: 1px solid ${theme.colors.input.border};

  border-radius: 14px;

  box-shadow: 0px 12px 24px rgba(16, 24, 40, 0.08),
    0px 2px 6px rgba(16, 24, 40, 0.04);

  scrollbar-width: thin;
`

export const DropdownItem = styled.button`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 12px;

  padding: 12px 14px;

  border: none;
  border-radius: 10px;

  background: transparent;

  text-align: left;

  cursor: pointer;

  transition: background 0.18s ease, transform 0.12s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  &:active {
    transform: scale(0.99);
  }
`

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;

  min-width: 0;
`

export const ItemTitle = styled.div`
  color: ${theme.colors.text.primary};

  font-size: ${theme.fontSizes.sm};

  font-weight: 500;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ItemSubtitle = styled.div`
  margin-top: 2px;

  color: ${theme.colors.text.muted};

  font-size: ${theme.fontSizes.xs};
`

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 14px;

  color: ${theme.colors.text.muted};

  font-size: ${theme.fontSizes.sm};
`

export const EmptyState = styled.div`
  padding: 18px 14px;

  text-align: center;

  color: ${theme.colors.text.muted};

  font-size: ${theme.fontSizes.sm};
`

export const Spinner = styled.div`
  width: 14px;
  height: 14px;

  border-radius: 50%;

  border: 2px solid rgba(0, 0, 0, 0.12);

  border-top-color: ${theme.colors.text.primary};

  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

// import styled from '@emotion/styled'
// import {theme} from '../../../../theme'

// // wrapper
// export const Wrapper = styled.div`
//   position: relative;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   gap: ${theme.space[1]};
// `

// // dropdown container (same feel as Select)
// export const Dropdown = styled.div`
//   position: absolute;
//   top: calc(100% + 6px);
//   left: 0;
//   right: 0;

//   background: ${theme.colors.input.bg};
//   border: 1px solid ${theme.colors.input.border};
//   border-radius: ${theme.radii.xs};

//   box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);

//   z-index: 1000;

//   max-height: 220px;
//   overflow-y: auto;

//   display: flex;
//   flex-direction: column;
// `

// // empty state
// export const EmptyState = styled.div`
//   padding: ${theme.space[3]};
//   font-size: ${theme.fontSizes.sm};
//   color: ${theme.colors.text.muted};
// `

// // loading state
// export const LoadingState = styled.div`
//   padding: ${theme.space[3]};
//   font-size: ${theme.fontSizes.sm};
//   color: ${theme.colors.text.muted};
// `
